import { listen, qs, qsa } from '@fluorescent/dom';

const selectors = {
  form: '.selectors-form',
  list: '[data-disclosure-list]',
  toggle: '[data-disclosure-toggle]',
  input: '[data-disclosure-input]',
  option: '[data-disclosure-option]',
};

const classes = {
  visible: 'disclosure-list--visible',
};

function has(list, selector) {
  return list.map(l => l.contains(selector)).filter(Boolean);
}

export default function Disclosure(node) {
  const form = node.closest(selectors.form);
  const list = qs(selectors.list, node);
  const toggle = qs(selectors.toggle, node);
  const input = qs(selectors.input, node);
  const options = qsa(selectors.option, node);

  const events = [
    listen(toggle, 'click', handleToggle),
    listen(options, 'click', submitForm),
    listen(document, 'click', handleBodyClick),
    listen(toggle, 'focusout', handleToggleFocusOut),
    listen(list, 'focusout', handleListFocusOut),
    listen(node, 'keyup', handleKeyup),
  ];

  function submitForm(evt) {
    evt.preventDefault();
    const { value } = evt.currentTarget.dataset;

    input.value = value;
    form.submit();
  }

  function handleToggleFocusOut(evt) {
    const disclosureLostFocus = has([node], evt.relatedTarget).length === 0;

    if (disclosureLostFocus) {
      hideList();
    }
  }

  function handleListFocusOut(evt) {
    const childInFocus = has([node], evt.relatedTarget).length > 0;
    const isVisible = list.classList.contains(classes.visible);

    if (isVisible && !childInFocus) {
      hideList();
    }
  }

  function handleKeyup(evt) {
    if (evt.which !== 27) return;
    hideList();
    toggle.focus();
  }

  function handleToggle(evt) {
    const ariaExpanded =
      evt.currentTarget.getAttribute('aria-expanded') === true;
    evt.currentTarget.setAttribute('aria-expanded', !ariaExpanded);
    list.classList.toggle(classes.visible);
  }

  function handleBodyClick(evt) {
    const isOption = has([node], evt.target).length > 0;
    const isVisible = list.classList.contains(classes.visible);

    if (isVisible && !isOption) {
      hideList();
    }
  }

  function hideList() {
    toggle.setAttribute('aria-expanded', false);
    list.classList.remove(classes.visible);
  }

  function unload() {
    events.forEach(evt => evt());
  }

  return { unload };
}
